import { render } from "./LinkedInSvg.vue?vue&type=template&id=34cf9a43&bindings={}"
import script from "./LinkedInSvg.vue?vue&type=script&lang=ts"
export * from "./LinkedInSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script